import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, ModalController, NavController } from 'ionic-angular';
import * as moment from 'moment';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Globals } from '../../../../globals';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { AdvancedAnalyticsServices } from '../../advanced-analytics-services';
import { SelectBetweenDatetime } from '../../../components/popups/select-between-datetime/select-between-datetime';

/**
 * Generated class for the StockMovementsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-stock-movements',
  templateUrl: 'stock-movements.html',
})
export class StockMovementsPage {

  selectedReason: string = 'all'; // 'all' para mostrar todos
  loadingIndicator: boolean = false;
  //datatable
  rows = [];
  temp = [];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;

  // Lista de motivos disponibles
  reasonsList = [
    { value: 'all', label: this.translate.instant('general-todos') },
    { value: 'En mal estado', label: this.translate.instant('general-mal-estado') },
    { value: 'Cantidad de stock más baja', label: this.translate.instant('general-cantidad-stock-mas-baja') },
    { value: 'Compra de elementos', label: this.translate.instant('general-compra-elementos') },
    { value: 'Uso de los elementos en un receta', label: this.translate.instant('general-uso-elementos-en-receta') },
    { value: 'Otros', label: this.translate.instant('general-otros') }
  ];

  constructor(public navCtrl: NavController,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public http: HttpClient,
    public advancedAnalyticsServices: AdvancedAnalyticsServices,
    public modalCtrl: ModalController) {
    // Establecer fechas por defecto: últimos 90 días
    this.advancedAnalyticsServices.date1 = moment().subtract(90, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss');
    this.advancedAnalyticsServices.date2 = moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss');
    this.getAnalyticsData();
  }

  //funcion que abre el modal para seleccionar fechas
  openSelectDatetimeModal() {
    let profileModal = this.modalCtrl.create(SelectBetweenDatetime, {
      title: this.translate.instant('analytics-titulo-fechas'),
      date_first: this.advancedAnalyticsServices.date1,
      date_last: this.advancedAnalyticsServices.date2,
      cash_bool: false,
    });
    profileModal.onDidDismiss(data => {
      if (data) {
        this.advancedAnalyticsServices.date1 = data.date_first;
        this.advancedAnalyticsServices.date2 = data.date_last;
        this.getAnalyticsData();
      }
    });
    profileModal.present();
  }

  // Filtrar por motivo seleccionado
  filterByReason() {
    if (this.selectedReason === 'all') {
      this.rows = this.temp;
    } else {
      this.rows = this.temp.filter(item => {
        // El motivo puede estar al inicio del comentario o después de un guión
        const comment = item.comment || '';
        return comment.includes(this.selectedReason);
      });
    }
    // Resetear la paginación
    if (this.table) {
      this.table.offset = 0;
    }
  }

  async getAnalyticsData() {
    this.loadingIndicator = true;

    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment(this.advancedAnalyticsServices.date1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.advancedAnalyticsServices.date2).format('YYYY-MM-DD HH:mm:ss'))
      .set('currency_lang', this.globals.currency_lang);

    const url = this.globals.analytics_path + 'bistock/stock_increment_deduct_list_all';
    
    console.log('=== DEBUG ENDPOINT ===');
    console.log('URL completa:', url);
    console.log('analytics_path:', this.globals.analytics_path);
    console.log('Parámetros:', {
      public_key: this.globals.public_key,
      first_date: moment(this.advancedAnalyticsServices.date1).format('YYYY-MM-DD HH:mm:ss'),
      last_date: moment(this.advancedAnalyticsServices.date2).format('YYYY-MM-DD HH:mm:ss'),
      currency_lang: this.globals.currency_lang
    });
    console.log('======================');

    // Obtener todos los movimientos de stock (sin uid_element)
    // Endpoint basado en analytics/stock_indv_increment_deduct_list pero para todos los elementos
    this.http.post(url, params, {})
      .subscribe(async response => {
        this.loadingIndicator = false;
        //list
        console.log('=== DATOS RECIBIDOS DEL SERVIDOR ===');
        console.log('Response completo:', response);
        console.log('Lista de movimientos:', response['list']);
        if (response['list'] && response['list'].length > 0) {
          console.log('Primer movimiento (ejemplo):', response['list'][0]);
          console.log('Fecha del primer movimiento:', response['list'][0]['date']);
          console.log('Tipo de fecha:', typeof response['list'][0]['date']);
        }
        console.log('=====================================');
        this.temp = response['list'] || [];
        // Aplicar filtro inicial
        this.filterByReason();
      }, error => {
        this.loadingIndicator = false;
        console.log('=== ERROR AL OBTENER MOVIMIENTOS ===');
        console.log('Error completo:', error);
        console.log('Status:', error.status);
        console.log('URL intentada:', error.url);
        console.log('Método HTTP: POST');
        console.log('Parámetros enviados:', params.toString());
        console.log('=====================================');
        
        if (error.status === 404) {
          console.error('⚠️ El endpoint bistock/stock_increment_deduct_list_all devuelve 404.');
          console.error('Verifica en el servidor:');
          console.error('1. Que el endpoint esté registrado exactamente como: bistock/stock_increment_deduct_list_all');
          console.error('2. Que acepte método POST');
          console.error('3. Que los parámetros esperados sean: public_key, first_date, last_date, currency_lang');
          console.error('4. Que el servidor esté reiniciado después de crear el endpoint');
        }
        
        this.temp = [];
        this.rows = [];
      });
  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();

    // filter our data
    const temp = this.temp.filter(function (d) {
      return d.date.toLowerCase().indexOf(val) !== -1 || 
             (d.MODIFIER && d.MODIFIER.toLowerCase().indexOf(val) !== -1) ||
             (d.comment && d.comment.toLowerCase().indexOf(val) !== -1) ||
             !val;
    });

    // Aplicar también el filtro de motivo
    if (this.selectedReason !== 'all') {
      const filtered = temp.filter(item => {
        const comment = item.comment || '';
        return comment.includes(this.selectedReason);
      });
      this.rows = filtered;
    } else {
      this.rows = temp;
    }
    
    // Whenever the filter changes, always go back to the first page
    if (this.table) {
      this.table.offset = 0;
    }
  }
}




// WEBPACK FOOTER //
// ./src/pages/analytics/reports/stock-movements/stock-movements.ts